import React, { useState } from "react";
import { changePassword } from "../../../http/api";
import { useTranslation } from "react-i18next";


const PasswordSection = () => {

    const { t } = useTranslation();

    const [form, setForm] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {

        setForm(prev => ({

            ...prev,
            [e.target.name]:
                e.target.value

        }));

        setError("");
        setSuccess("");
    };


    const handleSubmit = async () => {

        try {

            setLoading(true);

            await changePassword(form);

            setSuccess(
                t("passwordSection.success.passwordUpdated")
            );

            setForm({

                currentPassword: "",
                newPassword: "",
                confirmPassword: ""

            });

        }

        catch (err) {
            setError(
                t(
                    `passwordErrors.${err.message}`
                )
            );
        }

        finally {

            setLoading(false);

        }

    };



    return (

        <section className="settings-card">

            <h3>
                {t("passwordSection.title")}
            </h3>

            <input
                type="password"
                name="currentPassword"
                placeholder={
                    t("passwordSection.placeholders.currentPassword")
                }
                value={form.currentPassword}
                onChange={handleChange}
            />

            <input
                type="password"
                name="newPassword"
                placeholder={
                    t("passwordSection.placeholders.newPassword")
                }
                value={form.newPassword}
                onChange={handleChange}
            />

            <input
                type="password"
                name="confirmPassword"
                placeholder={
                    t("passwordSection.placeholders.confirmPassword")
                }
                value={form.confirmPassword}
                onChange={handleChange}
            />

            {error && (

                <div className="pwd-error-message">

                    ✖ {error}

                </div>

            )}

            {success && (

                <div className="pwd-success-message">

                    ✔ {success}

                </div>

            )}

            <div className="settings-actions">

                <button
                    className="btn primary"
                    onClick={handleSubmit}
                    disabled={loading}
                >

                    {
                        loading
                            ? t("passwordSection.buttons.updating")
                            : t("passwordSection.buttons.update")
                    }

                </button>

            </div>

        </section>

    )

}

export default PasswordSection;